module.exports = __webpack_public_path__ + "static/media/quote.e7ffd0e9.svg";